import React from 'react';

export default class DoorIcon extends React.Component{	
   render() {
	 return (
		<svg className={this.props.className} xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 164.117 164.117" >
			<g>
				<path d="M90.381,160.612V3.504c0-1.937-1.57-3.504-3.504-3.504H8.03C6.097,0,4.526,1.567,4.526,3.504v157.107
					c0,1.938,1.571,3.505,3.504,3.505h78.847C88.811,164.117,90.381,162.549,90.381,160.612z M83.373,157.108H11.535V7.008h71.838
					V157.108z"/>
				<path d="M22.633,99.873h48.475c1.934,0,3.504-1.567,3.504-3.505V17.521c0-1.937-1.571-3.504-3.504-3.504H22.633
					c-1.934,0-3.504,1.567-3.504,3.504v78.846C19.128,98.305,20.699,99.873,22.633,99.873z M26.137,21.026h41.466v71.838H26.137V21.026
					z"/>
				<path d="M156.087,99.873c1.937,0,3.504-1.567,3.504-3.505V17.521c0-1.937-1.567-3.504-3.504-3.504h-48.476
					c-1.934,0-3.504,1.567-3.504,3.504v78.846c0,1.938,1.57,3.505,3.504,3.505H156.087z M111.116,60.449h17.23v32.415h-17.23V60.449z
					M135.355,92.864V60.449h17.227v32.415H135.355z M152.582,53.44h-17.227V21.026h17.227V53.44z M128.347,21.026V53.44h-17.23V21.026
					H128.347z"/>
				<path d="M71.689,107.171H23.218c-1.934,0-3.504,1.567-3.504,3.505v34.167c0,1.937,1.571,3.504,3.504,3.504h48.472
					c1.934,0,3.504-1.567,3.504-3.504v-34.167C75.193,108.739,73.623,107.171,71.689,107.171z M68.185,141.338H26.722V114.18h41.463
					V141.338z"/>
			</g>
		</svg>
	 )
   }
}


// WEBPACK FOOTER //
// ./src/icons/door-and-window.js